// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Qx4s","productName":"Table_productName__1lUtF"};